import axios from "axios";
import qs from 'qs'


let beneficiarySvc = process.env.VUE_APP_CARD_USER_API_URL;
let messagesSvc = process.env.VUE_APP_MESSAGES_API_URL;
let companySvc = process.env.VUE_APP_COMPANY_API_URL;
let companyRoot = process.env.VUE_APP_COMPANY_USER_ROOT;
let beneficiaryRoot = process.env.VUE_APP_CARD_USER_ROOT;

const beneficiaryAxiosInstance = axios.create({
	baseURL: beneficiarySvc,
});

const messagesAxiosInstance = axios.create({
	baseURL: messagesSvc,
});

const configAxiosInstance = axios.create({
	baseURL: "https://api.upmoldova.md/cnf/",
	// baseURL: "https://app.uponline.ro/cnf/",
});

const companyAxiosInstance = axios.create({
	baseURL: companySvc,
});

// const querystring = require("querystring");

export default {
	commonsService: {
		async getConfigFile(language, mode) {
			if (!sessionStorage.getItem(mode + "_jsonFile")) {
				await configAxiosInstance
					.get(language + "/" + mode + "_config" + (process.env.VUE_APP_ENV === 'production' ? "" : "_staging")  +".json", {
						mode: "cors",
						headers: {
							"Content-Type": "text/plain",
							Accept: "text/plain",
						},
					})
					.then((response) => {
						sessionStorage.setItem(
							mode + "_jsonFile",
							JSON.stringify(response.data)
						);
					})

					.catch((error) => {
						return error;
					});
			}
			axios.defaults.headers.common["api_key"] =
				process.env.VUE_APP_CARD_USER_API_KEY;
		},
		sendMail(formData) {
			return messagesAxiosInstance.post(
				"/message_services/v1/mail_messages",
				formData,
				{
					headers: {
						Authorization: "Basic " + btoa("acioc:acioc"),
						"Content-Type": "application/json;charset=UTF-8",
						api_key: "dOQpzn113eMDdBr36ngKVlbz",
					},
				}
			);
		},
		sendForm(formData) {
			return messagesAxiosInstance.post(
				"/message_services/v1/form_messages",
				formData,
				{
					headers: {
						"Content-Type": "application/json;charset=UTF-8",
						api_key: "dOQpzn113eMDdBr36ngKVlbz",
					},
				}
			);
		},
		oAuthLogin(formData, uuid) {
			let dataForm = {
				scope: formData.scope,
				grant_type: "password",
				username: formData.username,
				password: formData.password,
			};
			return beneficiaryAxiosInstance.post(
				beneficiaryRoot + "/v1/tokens",
				qs.stringify(dataForm),
				{
					headers: {
						Authorization: "Basic " + btoa(process.env.VUE_APP_AUTHENTICATION_BASIC),
						"Content-Type": "application/x-www-form-urlencoded",
						"X-Up-OAuth": formData.userOAuth,
						"X-Up-Device": uuid
					},
				}
			);
		},
		
	},
	beneficiaryService: {
		userLogin(formData, recaptcha, uuid, extraHeaders = {}) {
			let dataForm = {
				scope: "web",
				grant_type: "password",
				username: formData.username,
				password: formData.password,
			};
			const baseHeaders = {
				"Authorization": "Basic " + btoa(process.env.VUE_APP_AUTHENTICATION_BASIC),
                "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
				"X-Up-Device-Id": uuid,
			};
			const customHeaders = {};
			Object.entries(extraHeaders).forEach(([key, value]) => {
				if (value !== undefined && value !== null) {
					customHeaders[key] = value;
				}
			});
			const mergedHeaders = {
				...baseHeaders,
				...(recaptcha !== null ? { "X-Up-Captcha": recaptcha } : {}),
				...customHeaders,
			};
			const config = {
				headers: mergedHeaders,
			};
			return beneficiaryAxiosInstance.post(
				beneficiaryRoot + "/v1/tokens",
				qs.stringify(dataForm),
				config
			);
		},

		sendLoginOtp(otpForm, token){
			return beneficiaryAxiosInstance.post(
				beneficiaryRoot + "/v1/checks/otp",
				otpForm,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		requestTokenForRegistration(myScope) {
			let dataForm = {
				scope: myScope,
				grant_type: "client_credentials",
			};
			return beneficiaryAxiosInstance.post(
				beneficiaryRoot + "/v1/tokens",
				qs.stringify(dataForm),
				{
					headers: {
						Authorization:
							"Basic " + btoa(process.env.VUE_APP_AUTHENTICATION_BASIC),
						"Content-Type": "application/x-www-form-urlencoded",
					},
				}
			);
		},
		userCheckForRegistration(formData, token, recaptcha) {
			let dataForm = {
				pan: formData.cardNumber,
				code: formData.code,
				lang: localStorage.language,
			};
			return beneficiaryAxiosInstance.post(
				beneficiaryRoot + "/v2/app_logins",
				dataForm,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
						"X-Up-Captcha": recaptcha,
					},
				}
			);
		},
		userGetInvitationInfos(params, token) {
			return beneficiaryAxiosInstance.get(
				beneficiaryRoot +  "/v1/app_invitations/search?" + params,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		userGetActivationInfos(params, token) {
			return beneficiaryAxiosInstance.get(
				beneficiaryRoot + "/v1/app_logins/search?" + params,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		confirmBeneficaryData(beneficiaryData, token) {
			return beneficiaryAxiosInstance.put(
				beneficiaryRoot + "/v1/app_logins/" + beneficiaryData.id,
				beneficiaryData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		confirmBeneficaryInvite(beneficiaryData, token) {
			return beneficiaryAxiosInstance.put(
				beneficiaryRoot + "/v1/app_invitations/" + beneficiaryData.id,
				beneficiaryData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		confirmBeneficaryDataV2(beneficiaryData, token) {
			return beneficiaryAxiosInstance.put(
				beneficiaryRoot + "/v2/app_logins/" + beneficiaryData.id,
				beneficiaryData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		userCheckForPasswordReset(formData, token) {
			return beneficiaryAxiosInstance.post(
				beneficiaryRoot + "/v2/app_passwords",
				formData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		resetBeneficiaryPassword(passwordId ,passwordData, token) {
			return beneficiaryAxiosInstance.put(
				beneficiaryRoot + "/v1/app_passwords/" + passwordId,
				passwordData,
				{
                    headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		beneficiaryCheckForPasswordReset(formData, token) {
			return beneficiaryAxiosInstance.post(
				beneficiaryRoot + "/v1/app_passwords",
				formData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		validateOtp(otpData, token) {
			return beneficiaryAxiosInstance.put(
				beneficiaryRoot + "/v1/app_passwords/" ,
				otpData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		sendOtp(otpData, headers) {
			return beneficiaryAxiosInstance.post(
				beneficiaryRoot + "/v1/checks/otp" ,
				otpData,
				{
					headers: headers
				}
			);
		}
	},
	companyService: {
		userLogin(formData, recaptcha) {
			let dataForm = {
				scope: "webclient",
				grant_type: "password",
				username: formData.username,
				password: formData.password,
			};
			let config = {};
			if (recaptcha !== null) {
				config = {
					headers: {
						Authorization:
							"Basic " + btoa(process.env.VUE_APP_AUTHENTICATION_BASIC),
						"Content-Type": "application/x-www-form-urlencoded",
						"X-Up-Captcha": recaptcha,
					},
				};
			} else {
				config = {
					headers: {
						Authorization:
							"Basic " + btoa(process.env.VUE_APP_AUTHENTICATION_BASIC),
						"Content-Type": "application/x-www-form-urlencoded",
					},
				};
			}
			return companyAxiosInstance.post(
				companyRoot + "/v1/tokens",
				qs.stringify(dataForm),
				config
			);
		},
		sendLoginOtp(otpForm, token){
			return beneficiaryAxiosInstance.post(
				companyRoot + "/v1/checks/otp",
				otpForm,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		requestTokenForRegistration(myScope) {
			let dataForm = {
				scope: myScope,
				grant_type: "client_credentials",
			};
			return companyAxiosInstance.post(
				companyRoot + "/v1/tokens",
				qs.stringify(dataForm),
				{
					headers: {
						Authorization:
							"Basic " + btoa(process.env.VUE_APP_AUTHENTICATION_BASIC),
						"Content-Type": "application/x-www-form-urlencoded",
					},
				}
			);
		},
		userCheckForRegistration(formData, token, recaptcha) {
			let dataForm = {
				code: formData.code,
				identification: formData.identification,
				email: formData.email,
				from_source_id: formData.type,
				lang: localStorage.language,
			};
			return companyAxiosInstance.post(
				companyRoot + "/v2/app_logins",
				dataForm,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
						"X-Up-Captcha": recaptcha,
					},
				}
			);
		},
		userGetActivationInfos(params, token) {
			return companyAxiosInstance.get(
				companyRoot + "/v2/app_logins/search?" + params,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		confirmCompanyData(companyData, token) {
			return companyAxiosInstance.put(
				companyRoot + "/v2/app_logins/" + companyData.id,
				companyData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		userCheckForPasswordReset(formData, token) {
			return companyAxiosInstance.post(
				companyRoot + "/v1/app_passwords",
				formData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		userResetCodeCheck(params, token) {
			return companyAxiosInstance.get(
				companyRoot + "/v1/app_passwords/search?" + params,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		companyPasswordReset(passwordData, token) {
			return companyAxiosInstance.put(
				companyRoot + "/v1/app_passwords/" + passwordData.password_id,
				passwordData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		getNomenclature(params, token) {
			return companyAxiosInstance.get(
				companyRoot + "/v1/items/search?" + params,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
	},
};
